export var Status;
(function (Status) {
    /**
     * Succeeded reading the `LocaleConfig` structure stored in an XML file.
     *
     * @since 1.0.0
     */
    Status[Status["SUCCESS"] = 0] = "SUCCESS";
    /**
     * No `android:localeConfig` tag on pointing to an XML file that stores the `LocaleConfig`.
     *
     * @since 1.0.0
     */
    Status[Status["NOT_SPECIFIED"] = 1] = "NOT_SPECIFIED";
    /**
     * Malformed input in the XML file where the `LocaleConfig` was stored.
     *
     * @since 1.0.0
     */
    Status[Status["PARSING_FAILED"] = 2] = "PARSING_FAILED";
})(Status || (Status = {}));
//# sourceMappingURL=definitions.js.map